import React from 'react'

export default function Footer() {
    return (
        <div>
            <footer className="footer mt-auto py-3" style={{ backgroundColor: "#000000" }}>
                <div className="container  text-light text-white">
                    <div className='row'>
                        <div className='col-lg-10 text-start'>
                            <p>© 2020 Freese and Nichols, Inc. | <a className="text-light text-white" target="_blank" href="https://www.burlesontx.com/">City of Burleson,TX</a></p>
                        </div>
                        <div className='col-lg-2 text-end'>
                            <p><a href="#" className=" text-light text-white">Back to top</a></p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}
